export const isPrimitive = (val) =>
  !['function', 'object'].includes(typeof val) || val === null;
